import { Spin } from 'antd'
import CantileverButton from 'components/CantileverButton'
import React from 'react'
import styled from 'styled-components'
import { GeckoSiteObservation } from 'types'

import { ImageUploadButton } from './ImageUploadButton'

const AnimatedButton = styled(CantileverButton)`
  transition: all 0.15s ease-in-out;

  &:hover {
    transform: scale(1.02);
    filter: brightness(1.1);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: scale(0.98);
    filter: brightness(0.9);
    transition: all 0.05s ease-in-out;
  }
`

interface ActionButtonsProps {
  observation?: GeckoSiteObservation
  formData: Partial<GeckoSiteObservation['data']>
  isSaving: boolean
  isDeleting: boolean
  handleSave: (data: Partial<GeckoSiteObservation['data']>) => void
  handleDelete: () => void
  handleImageUpload: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const buttonContainerStyles: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  gap: '10px',
  marginTop: '15px',
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({
  observation,
  formData,
  isSaving,
  isDeleting,
  handleSave,
  handleDelete,
  handleImageUpload,
}) => {
  return (
    <div style={buttonContainerStyles}>
      <div style={{ display: 'flex', gap: '10px' }}>
        {observation && (
          <AnimatedButton
            danger
            onClick={handleDelete}
            disabled={isDeleting}
            style={{
              minWidth: '80px',
              backgroundColor: '#dc3545',
              color: 'white',
              border: 'none',
            }}>
            {isDeleting ? <Spin size='small' /> : 'Delete'}
          </AnimatedButton>
        )}
        <AnimatedButton
          onClick={() => handleSave(formData)}
          disabled={isSaving}
          style={{
            backgroundColor: '#28a745',
            minWidth: '80px',
            color: 'white',
            border: 'none',
          }}>
          {isSaving ? <Spin size='small' /> : 'Save'}
        </AnimatedButton>
        <ImageUploadButton
          handleImageUpload={handleImageUpload}
          disabled={isSaving || isDeleting}
        />
      </div>
    </div>
  )
}
